import scrollToElement from 'scroll-to-element';
import { on } from 'delegated-events';
import helpers from './helpers.js';

/*
===================================================================
Scroll to
===================================================================
*/
export default (function () {
  return {
    init() {
      const inWay = document.querySelectorAll('.sticky-nav');
      let offset = 0;

      helpers.forEach(inWay, (i, el) => {
        offset -= el.offsetHeight;
      });

      on('click', '.js-skip-link', (e) => {
        e.preventDefault();
        const link = e.currentTarget;
        const targ = link.getAttribute('href');
        const elem = document.querySelector(targ);

        link.blur();

        scrollToElement(elem, {
          duration: 700,
          offset,
        });
      });

      const scrollOnLoad = document.querySelector('.js-scroll-onload');

      if (scrollOnLoad != null) {
        const durationLoad = parseInt(scrollOnLoad.getAttribute('data-duration'), 10);
        let duration = !Number.isNaN(durationLoad) ? durationLoad : 700;
        // scrollToElement treats 0 as falsey so ignores 0;
        if (duration === 0) duration = 1;
        window.onload = (e) => {
          scrollToElement(scrollOnLoad, {
            duration,
            offset,
          });
        };
      }
    },
  };
}());
